<template>
  <bordered-container title='Gekoppelde polisgegevens'>
    <employee-policy
      v-for="(participation, i) in employee.allParticipations"
      :key="i + '-participation-' + employee.id"
      :participation="participation"
      :policies="employeePolicies" />

    <div v-if="!employee.allParticipations || employee.allParticipations.length === 0" style='text-align: center; padding: 40px;'>
      <p>{{ employee.name }} neemt nog niet deel aan een polis.</p>
    </div>
  </bordered-container>

</template>

<script>
/* TO-DO: Should not render element if no policy found.
          Instead should render element which tells user there is no
          policy for the participation found */

import Compositions from '@/views/helpers/compositions';
import EmployeePolicy from '@/views/components/employee-details/EmployeePolicy.vue';
import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';

export default {
  name: 'EmployeePolicies',
  props: {
    employee: Object
  },
  data () {
    return {
      editLink: {
        text: 'Polisdeelname Toevoegen',
        onClick: null
      }
    };
  },
  components: {
    EmployeePolicy,
    BorderedContainer
  },
  computed: {
    employeePolicies () {
      return Compositions.getPoliciesFromParticipations(
        this.employee.allParticipations, this.$store.getters.policies);
    }
  }
};
</script>
